import React from "react";
import styles from './index.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div>
        Copyright © {new Date().getFullYear()} StudyHub. All Rights Reserved.
        Designed and Developed by{" "}
        <a
          href="https://ardillalabs.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Ardillalabs (Pvt) Ltd
        </a>.
      </div>
    </footer>
  );
};

export default Footer;